export default __webpack_public_path__ + "static/media/molar-II.87eececc.png";